import { useWSModalCustom, WSModal } from "@wingspanhq/fe-component-library";
import { WSModalCustomProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSModal/useWSModalCustom.hook";
import React from "react";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { useWorkLogHistoryResources } from "../hooks/useWorkLogHistoryResources";

type ModalProps = WSModalCustomProps<void> & {
  workLogId: string;
};

const ModalWorkLogHistory: React.FC<ModalProps> = ({
  workLogId,
  ...modalProps
}) => {
  const scope = useWorkLogHistoryResources(workLogId);

  return (
    <WSModal title="Work log history" {...modalProps}>
      <ResourceHistory resources={scope} drillDownResourceType="WorkItem" />
    </WSModal>
  );
};

export const useModalWorkLogHistory = () =>
  useWSModalCustom(ModalWorkLogHistory);

export const WorkLogHistoryWidget: React.FC<{
  workLogId: string;
}> = ({ workLogId }) => {
  const modal = useModalWorkLogHistory();
  const scope = useWorkLogHistoryResources(workLogId);

  return (
    <ResourceHistory
      resources={scope}
      onViewAll={() => {
        modal.open({ workLogId });
      }}
    />
  );
};
